import { StateCreator } from 'zustand'
import { Store } from '../type'

type ConfigurationSlice = Pick<
  Store,
  'setEnvironment' | 'environment' | 'setBrand' | 'brand' | 'setLang' | 'lang'
>

export const configurationSlice: StateCreator<
  Store,
  [],
  [],
  ConfigurationSlice
> = (set) => ({
  setEnvironment: (environment) => set({ environment }),
  setBrand: (brand) => set({ brand }),
  setLang: (lang) => set({ lang }),
  lang: 'en-GB',
  environment: 'dev',
  brand: 'cottages.com',
})
